import Cookies from 'js-cookie';

export default {
  init() {
    
    $('.salife-bottom-modal').on('initBottomModal', function(){
      
      var el = $(this);
      
      $('.salife-bottom-modal__close', el).click(function(e){
        e.preventDefault();
        $(el).trigger('closeBottomModal');
      });
      
    }).on('openBottomModal', function() {
      
      var el = $(this);
      $('body').addClass('showing-bottom-modal').removeClass('hiding-bottom-modal');
      $(el).addClass('salife-bottom-modal--showing');
      
      setTimeout(function() {
        //$(el).trigger('closeBottomModal');
      }, 15000);
      
    }).on('closeBottomModal', function() {
      
      var el = $(this);
      $('body').addClass('hiding-bottom-modal').removeClass('showing-bottom-modal');
      $(el).removeClass('salife-bottom-modal--showing');
      
      setTimeout(function() {
        $('body').removeClass('showing-bottom-modal').removeClass('hiding-bottom-modal');
      }, 1000);
      
    }).trigger('initBottomModal');
    
    
  },
  finalize() {

      var popupEl             = $('#bottom-modal'),
          popupReminderEl     = $('#bottom-modal-reminder'),
          popupID             = $(popupEl).data('popup-id'), 
          popupExpiry         = parseInt($(popupEl).data('popup-frequency')), 
          popupTimer          = parseInt($(popupEl).data('popup-timer')) * 1000, 
          popupReminderTime   = parseInt(parseFloat($(popupEl).data('popup-reminder')) * 60), // In minutes
          lastShownTimestamp  = Cookies.get(popupID), 
          lastShownReminder   = Cookies.get(popupID+'-reminder'), 
          currentDate         = new Date(),
          currentTimestamp    = currentDate.getTime(), 
          lastShownDifference = (currentTimestamp - lastShownTimestamp),
          lastShownHours      = Math.floor((lastShownDifference % 86400000) / 3600000), // eslint-disable-line
          lastShownMinutes    = Math.round(((lastShownDifference % 86400000) % 3600000) / 60000);
      
      if(!popupTimer) {
        popupTimer = 3000;
      }
      
      setTimeout(function() {
      
        if(lastShownTimestamp && popupExpiry) {
          
          if(lastShownReminder) {
            // Reminder shown, do nothing...
            
          } else if(lastShownMinutes >= popupReminderTime) {
            
            // Show Reminder
            
            $(popupReminderEl).trigger('openBottomModal');
            Cookies.set(popupID+'-reminder', currentTimestamp, { expires: popupExpiry });
            
          } else {
            // console.log('SHOW REMINDER SOON ('+ (popupReminderTime-lastShownMinutes) +' mins)');
          }
          
        } else {
          
          Cookies.set(popupID, currentTimestamp, { expires: popupExpiry });
          $(popupEl).trigger('openBottomModal');
          
        }
        
      }, popupTimer); 

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/bottomModal.js